import configAxios from "../configuration/configAxios";
import {errorHandlerServices} from "../configuration/errorHandle";
import {useMutation, UseMutationResult, useQuery, UseQueryResult} from "@tanstack/react-query";
import Cookies from "js-cookie";
import {ID_TOKEN} from "../../conf";
import queryClient from "../configuration/queryClient";
import {UserKeycloakInterface} from "../interface/UserKeycloakInterface";
import {UserInterface} from "../interface/UserInterface";
import {showToast} from "../../components/general/CustomToast";

function getHeadersKeycloak() {
    return {
        'Accept': '*/*',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${Cookies.get(ID_TOKEN)}`,
    }
}

export const getListAllUsers = async () => {
    return await configAxios.get(`/ms-menus/usuario/findAll-usuario`)
        .then(response => {
            return response.data
        }).catch(error => {
            errorHandlerServices(error, true)
            throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/usuario/findAll-usuario`);
        })
}

export const useListAllUsers = (): UseQueryResult<any, Error> => {
    return useQuery({queryKey: ['getListAllUsers'], queryFn: () => getListAllUsers()});
}

export const getListAllUsersStatusActive = async () => {
    return await configAxios.get(`/ms-menus/usuario/find-all-status-usuario`, {
        params: {
            status: 1
        }
    })
        .then(response => {
            return response.data
        }).catch(error => {
            errorHandlerServices(error, true)
            throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/usuario/findAll-usuario`);
        })
}

export const useListAllUsersStatus = (): UseQueryResult<any, Error> => {
    return useQuery({queryKey: ['getListAllUsersStatusActive'], queryFn: () => getListAllUsersStatusActive()});
}

export const createUser = async (data: any) => {
    return await configAxios.post(`/auth/admin/realms/pagina-web-ricaurte/users`, {
        firstName: data?.name,
        lastName: data?.lastname,
        username: data?.username,
        email: data?.email,
        enabled: true,
        credentials: data?.credentials
    }, {
        headers: getHeadersKeycloak()
    })
        .then((response) => {
            return configAxios.post(`/ms-menus/usuario/add-usuario`, data).then(resp => {
                return resp.data
            }).catch(error => {
                errorHandlerServices(error, true)
                throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/usuario/findAll-usuario`);
            })
        }).catch(error => {
            errorHandlerServices(error, true)
            throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/usuario/findAll-usuario`);
        })
}

export const useCreateUser = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: any) => createUser(data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['getListAllUsers']})
        }
    });
}

export const findUserKeycloak = async (data: any) => {
    return await configAxios.get(`/auth/admin/realms/pagina-web-ricaurte/users?username=${data.username}`, {
        headers: getHeadersKeycloak()
    })
        .then((response) => {
            if (response.data && response.data.length > 0) {
                let resp = undefined
                response.data.forEach((item: UserKeycloakInterface) => {
                    if (item.username?.toUpperCase() === data.username) {
                        resp = item
                    }
                })
                return resp
            }
            return response.data && response.data.length > 0 ? response.data[0] : response?.data;
        }).catch(error => {
            errorHandlerServices(error, true)
            throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /realms/pagina-web-ricaurte/users`);
        })
}

export const useFindUserKeycloak = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: any) => findUserKeycloak(data),
    });
}

export interface UserChangeData {
    user: UserInterface,
    userKeycloak: UserKeycloakInterface
}

export const changeStatusUser = async (data: UserChangeData) => {
    return await configAxios.put(`/auth/admin/realms/pagina-web-ricaurte/users/${data.userKeycloak.id}`, data.userKeycloak, {
        headers: getHeadersKeycloak()
    })
        .then((response) => {
            if (data.userKeycloak.enabled) {
                return configAxios.post(`/ms-menus/usuario/habilitar-usuario`, null,
                    {params: {idUsuario: data.user.username}}).then(resp => {
                    showToast(`Acción completada`, 'success')
                    return resp.data
                }).catch(error => {
                    errorHandlerServices(error, true)
                    throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/usuario/findAll-usuario`);
                })
            } else {
                return configAxios.delete(`/ms-menus/usuario/delete-usuario`,
                    {params: {idUsuario: data.user.username}}).then(resp => {
                    return resp.data
                }).catch(error => {
                    errorHandlerServices(error, true)
                    throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/usuario/findAll-usuario`);
                })
            }
        }).catch(error => {
            errorHandlerServices(error, true)
            throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/usuario/findAll-usuario`);
        })
}

export const useChangeStatusUser = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: UserChangeData) => changeStatusUser(data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['getListAllUsers']})
        }
    });
}

export const updateUser = async (data: UserChangeData) => {
    return await configAxios.put(`/auth/admin/realms/pagina-web-ricaurte/users/${data.userKeycloak.id}`, data.userKeycloak, {
        headers: getHeadersKeycloak()
    })
        .then((response) => {
            return configAxios.post(`/ms-menus/usuario/put-usuario/`, null,
                {
                    params: {
                        idUsuario: data.user.username,
                        nombre: data.user.nombre,
                        apellido: data.user.apellido,
                        celular: data.user.celular,
                        correo: data.user.correo,
                        rol: data.user.rol,
                    }
                }).then(resp => {
                return resp.data
            }).catch(error => {
                errorHandlerServices(error, true)
                throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/usuario/findAll-usuario`);
            })
        }).catch(error => {
            errorHandlerServices(error, true)
            throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/usuario/findAll-usuario`);
        })
}

export const useUpdateUser = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: UserChangeData) => updateUser(data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['getListAllUsers']})
        }
    });
}
